import { render, staticRenderFns } from "./VFilterPrice.vue?vue&type=template&id=c92076a6&"
import script from "./VFilterPrice.vue?vue&type=script&lang=js&"
export * from "./VFilterPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports